import { render } from "./InnerFooter.vue?vue&type=template&id=6427e8ce&scoped=true"
import script from "./InnerFooter.vue?vue&type=script&lang=js"
export * from "./InnerFooter.vue?vue&type=script&lang=js"

import "./InnerFooter.vue?vue&type=style&index=0&id=6427e8ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6427e8ce"]])

export default __exports__